// src/app/redux/actions/paramDomainesThemesActions.js

export const CLEAR_BULK_REVIEW = "CLEAR_BULK_REVIEW";

export const FETCH_DOMAINES_REQUEST = "FETCH_DOMAINES_REQUEST";
export const FETCH_DOMAINES_SUCCESS = "FETCH_DOMAINES_SUCCESS";
export const FETCH_DOMAINES_FAIL = "FETCH_DOMAINES_FAIL";

export const FETCH_THEMES_REQUEST = "FETCH_THEMES_REQUEST";
export const FETCH_THEMES_SUCCESS = "FETCH_THEMES_SUCCESS";
export const FETCH_THEMES_FAIL = "FETCH_THEMES_FAIL";

export const FETCH_THEMES_BY_DOMAINE_REQUEST = "FETCH_THEMES_BY_DOMAINE_REQUEST";
export const FETCH_THEMES_BY_DOMAINE_SUCCESS = "FETCH_THEMES_BY_DOMAINE_SUCCESS";
export const FETCH_THEMES_BY_DOMAINE_FAIL = "FETCH_THEMES_BY_DOMAINE_FAIL";

export const CREATE_DOMAINE_REQUEST = "CREATE_DOMAINE_REQUEST";
export const CREATE_DOMAINE_SUCCESS = "CREATE_DOMAINE_SUCCESS";
export const CREATE_DOMAINE_FAIL = "CREATE_DOMAINE_FAIL";

export const UPDATE_DOMAINE_REQUEST = "UPDATE_DOMAINE_REQUEST";
export const UPDATE_DOMAINE_SUCCESS = "UPDATE_DOMAINE_SUCCESS";
export const UPDATE_DOMAINE_FAIL = "UPDATE_DOMAINE_FAIL";

export const DELETE_DOMAINE_REQUEST = "DELETE_DOMAINE_REQUEST";
export const DELETE_DOMAINE_SUCCESS = "DELETE_DOMAINE_SUCCESS";
export const DELETE_DOMAINE_FAIL = "DELETE_DOMAINE_FAIL";

export const CREATE_THEME_REQUEST = "CREATE_THEME_REQUEST";
export const CREATE_THEME_SUCCESS = "CREATE_THEME_SUCCESS";
export const CREATE_THEME_FAIL = "CREATE_THEME_FAIL";

export const UPDATE_THEME_REQUEST = "UPDATE_THEME_REQUEST";
export const UPDATE_THEME_SUCCESS = "UPDATE_THEME_SUCCESS";
export const UPDATE_THEME_FAIL = "UPDATE_THEME_FAIL";

export const DELETE_THEME_REQUEST = "DELETE_THEME_REQUEST";
export const DELETE_THEME_SUCCESS = "DELETE_THEME_SUCCESS";
export const DELETE_THEME_FAIL = "DELETE_THEME_FAIL";

export const SET_PARAM_DOMAINES_THEMES_LOADING = "SET_PARAM_DOMAINES_THEMES_LOADING";
export const CLEAR_PARAM_DOMAINES_THEMES_ERROR = "CLEAR_PARAM_DOMAINES_THEMES_ERROR";

export const DOWNLOAD_DOMAINES_TEMPLATE_REQUEST = "DOWNLOAD_DOMAINES_TEMPLATE_REQUEST";
export const DOWNLOAD_DOMAINES_TEMPLATE_SUCCESS = "DOWNLOAD_DOMAINES_TEMPLATE_SUCCESS";
export const DOWNLOAD_DOMAINES_TEMPLATE_FAIL = "DOWNLOAD_DOMAINES_TEMPLATE_FAIL";

export const DOWNLOAD_THEMES_TEMPLATE_REQUEST = "DOWNLOAD_THEMES_TEMPLATE_REQUEST";
export const DOWNLOAD_THEMES_TEMPLATE_SUCCESS = "DOWNLOAD_THEMES_TEMPLATE_SUCCESS";
export const DOWNLOAD_THEMES_TEMPLATE_FAIL = "DOWNLOAD_THEMES_TEMPLATE_FAIL";

// Import excel
export const IMPORT_DOMAINES_EXCEL_REQUEST = "IMPORT_DOMAINES_EXCEL_REQUEST";
export const IMPORT_DOMAINES_EXCEL_SUCCESS = "IMPORT_DOMAINES_EXCEL_SUCCESS";
export const IMPORT_DOMAINES_EXCEL_FAIL = "IMPORT_DOMAINES_EXCEL_FAIL";

export const IMPORT_THEMES_EXCEL_REQUEST = "IMPORT_THEMES_EXCEL_REQUEST";
export const IMPORT_THEMES_EXCEL_SUCCESS = "IMPORT_THEMES_EXCEL_SUCCESS";
export const IMPORT_THEMES_EXCEL_FAIL = "IMPORT_THEMES_EXCEL_FAIL";

/* =========================
   ACTION CREATORS
========================= */

export const downloadDomainesTemplateRequest = () => ({
    type: DOWNLOAD_DOMAINES_TEMPLATE_REQUEST,
});

export const downloadThemesTemplateRequest = () => ({
    type: DOWNLOAD_THEMES_TEMPLATE_REQUEST,
});

export const importDomainesExcelRequest = (file) => ({
    type: IMPORT_DOMAINES_EXCEL_REQUEST,
    payload: file,
});

export const importThemesExcelRequest = (file) => ({
    type: IMPORT_THEMES_EXCEL_REQUEST,
    payload: file,
});

export const clearBulkReview = () => ({
    type: CLEAR_BULK_REVIEW,
});

export const setParamDomainesThemesLoading = (loading) => ({
    type: SET_PARAM_DOMAINES_THEMES_LOADING,
    payload: loading,
});

export const clearParamDomainesThemesError = () => ({
    type: CLEAR_PARAM_DOMAINES_THEMES_ERROR,
});

// Domaines
export const fetchDomainesRequest = () => ({ type: FETCH_DOMAINES_REQUEST });
export const fetchDomainesSuccess = (data) => ({ type: FETCH_DOMAINES_SUCCESS, payload: data });
export const fetchDomainesFail = (error) => ({ type: FETCH_DOMAINES_FAIL, error });

export const createDomaineRequest = (payload) => ({ type: CREATE_DOMAINE_REQUEST, payload });
export const createDomaineSuccess = (data) => ({ type: CREATE_DOMAINE_SUCCESS, payload: data });
export const createDomaineFail = (error) => ({ type: CREATE_DOMAINE_FAIL, error });

export const updateDomaineRequest = (id, payload) => ({ type: UPDATE_DOMAINE_REQUEST, payload: { id, payload } });
export const updateDomaineSuccess = (data) => ({ type: UPDATE_DOMAINE_SUCCESS, payload: data });
export const updateDomaineFail = (error) => ({ type: UPDATE_DOMAINE_FAIL, error });

export const deleteDomaineRequest = (id) => ({ type: DELETE_DOMAINE_REQUEST, payload: { id } });
export const deleteDomaineSuccess = (id) => ({ type: DELETE_DOMAINE_SUCCESS, payload: { id } });
export const deleteDomaineFail = (error) => ({ type: DELETE_DOMAINE_FAIL, error });

// Themes
export const fetchThemesRequest = () => ({ type: FETCH_THEMES_REQUEST });
export const fetchThemesSuccess = (data) => ({ type: FETCH_THEMES_SUCCESS, payload: data });
export const fetchThemesFail = (error) => ({ type: FETCH_THEMES_FAIL, error });

export const fetchThemesByDomaineRequest = (domaineId) => ({
    type: FETCH_THEMES_BY_DOMAINE_REQUEST,
    payload: { domaineId },
});
export const fetchThemesByDomaineSuccess = (data) => ({
    type: FETCH_THEMES_BY_DOMAINE_SUCCESS,
    payload: data,
});
export const fetchThemesByDomaineFail = (error) => ({
    type: FETCH_THEMES_BY_DOMAINE_FAIL,
    error,
});

export const createThemeRequest = (payload) => ({ type: CREATE_THEME_REQUEST, payload });
export const createThemeSuccess = (data) => ({ type: CREATE_THEME_SUCCESS, payload: data });
export const createThemeFail = (error) => ({ type: CREATE_THEME_FAIL, error });

export const updateThemeRequest = (id, payload) => ({ type: UPDATE_THEME_REQUEST, payload: { id, payload } });
export const updateThemeSuccess = (data) => ({ type: UPDATE_THEME_SUCCESS, payload: data });
export const updateThemeFail = (error) => ({ type: UPDATE_THEME_FAIL, error });

export const deleteThemeRequest = (id) => ({ type: DELETE_THEME_REQUEST, payload: { id } });
export const deleteThemeSuccess = (id) => ({ type: DELETE_THEME_SUCCESS, payload: { id } });
export const deleteThemeFail = (error) => ({ type: DELETE_THEME_FAIL, error });
